import { supabase } from "@/lib/supabase";

const BUCKET = process.env.REACT_APP_SUPABASE_STORAGE_BUCKET || "public";

/**
 * Upload a File to the configured Supabase Storage bucket.
 * Returns the public URL.
 */
export async function uploadImage(file, folder = "blogs") {
  if (!file) throw new Error("No file provided");
  const ext = file.name.split(".").pop();
  const path = `${folder}/${Date.now()}_${crypto.randomUUID()}.${ext}`;
  const { error: upErr } = await supabase.storage
    .from(BUCKET)
    .upload(path, file, { cacheControl: "3600", upsert: false });
  if (upErr) throw upErr;
  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return { url: data.publicUrl, path };
}

/**
 * Delete an image by its storage path (not full URL).
 * Returns true on success or if the file did not exist.
 */
export async function deleteImageByPath(path) {
  if (!path) return true;
  const { error } = await supabase.storage.from(BUCKET).remove([path]);
  return !error;
}

/**
 * Given a Supabase public URL, extract the storage path (bucket-relative).
 */
export function pathFromPublicUrl(url) {
  if (!url) return null;
  const marker = `/storage/v1/object/public/${BUCKET}/`;
  const idx = url.indexOf(marker);
  if (idx === -1) return null;
  return url.slice(idx + marker.length);
}

export const STORAGE_BUCKET = BUCKET;
